import sendRequest from "@/utils/request";

export const URLS = {
  QueryMeetingRoomOccupancyStatistics:
    "/api/DirectorClient/MeetingRoomOccupancyDirectorQuery/QueryMeetingRoomOccupancyStatistics",
  QueryMeetingRoomOccupancyDetail:
    "/api/DirectorClient/MeetingRoomOccupancyDirectorQuery/QueryMeetingRoomOccupancyDetail",
  QueryMeetingRoomApplies:
    "/api/DirectorClient/MeetingRoomApplyDirectorQuery/QueryMeetingRoomApplies",

  QueryMeetingRoomBuildings:
    "/api/DirectorClient/MeetingRoomBuildingDirectorQuery/QueryMeetingRoomBuildings",

  QueryMeetingRoomFloors:
    "/api/DirectorClient/MeetingRoomBuildingDirectorQuery/QueryMeetingRoomFloors",
  QueryMeetingRoomFloorMapImages: "/api/DirectorClient/MeetingRoomBuildingDirectorQuery/QueryMeetingRoomFloorMapImages",

  QueryMeetingRooms:
    "/api/DirectorClient/MeetingRoomBuildingDirectorQuery/QueryMeetingRooms"
};

const apis = {};
for (const key in URLS) {
  const url = URLS[key];
  apis[key] = (params, option = {}) => {
    return sendRequest(url, params, "post", option);
  };
}
export default apis;
